export const isAllConsentTrue = (
  consentDetail: Record<string, string | number | boolean>
) => {
  const consentValues = Object.values(consentDetail || {});
  const hasFalse = consentValues.some((item) => item === false);

  return !hasFalse;
};
